<template>
  <div ref="headerPageWrapper" id="header-page-wrapper">
    <div class="header-wrapper">
      <div class="flex-row align-items-center justify-content-between container-v-sm container-h-xxl">
        <slot name="header">
          <dd-dashboard-page-header>
            {{ header }}
          </dd-dashboard-page-header>
        </slot>
        <div class="flex-row justify-content-end align-items-center gap-md">
          <slot name="header-buttons"></slot>
        </div>
      </div>
      <div class="flex-row align-items-end justify-content-between">
        <slot name="tabs"></slot>
        <slot name="instance-buttons"></slot>
      </div>
    </div>

    <div class="flex-row ">
      <div class="content container-v-lg pt-0">
        <slot class="flex-shrink-1" name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import store from "./store";
export default {
  name: "DashboardHeaderPage.vue",
  props: {
    header: {
      type: String
    },
    breadCrumbs: {
      type: Array,
      required: false,
    },
    backHandler: {
      type: Function,
      required: false,
    },
  },
  created() {
    const STORE_KEY = `$_header_page`;
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  computed: {
    hasTabs() {
      return this.$slots.tabs?.length > 0;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.content.has-buttons {
  margin-right: 92px;
}
.content {
  width: 100%;
  height: 100%;
  overflow-x: clip;
  padding-left: $spacing-xxl;
  padding-right: $spacing-xxl;
}
.header-wrapper {
  background-color: white;
}
</style>
